import * as React from 'react';

export default () => {
    return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
        >
          <path d="M7.002 7.002V0h1.996v7.002H16v1.996H8.998V16H7.002V8.998H0V7.002h7.002z"></path>
        </svg>
    );
}